// src/pages/paxTypes/CreatePaxTypes.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditPaxTypes from "../../components/paxTypes/FormAddEditPaxTypes";
import { useNavigate } from "react-router-dom";

const CreatePaxTypes = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPaxTypes
                isEdit={false}
                onSubmitSuccess={() => navigate("/pax-types")}
            />
        </WrapperSection>
    );
};

export default CreatePaxTypes;